import { DM_DEADLINE_WINDOW_MS, DM_REPLY_WINDOW_MS } from '@rp/contracts'
import type { StatusTone } from '../design'

const HK = 'Asia/Hong_Kong'
export const LOCALE = 'zh-Hant-HK'

const TIME_FORMAT = new Intl.DateTimeFormat(LOCALE, { timeZone: HK, hour: '2-digit', minute: '2-digit', hour12: false })
const DATE_TIME_FORMAT = new Intl.DateTimeFormat(LOCALE, {
  timeZone: HK,
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
})

export const DM_WARNING_WINDOW_MS = 6 * 60 * 60 * 1000

const HOURS_PER_DAY = 24

export const formatTimeOfDay = (value: Date): string => TIME_FORMAT.format(value)
export const formatDateTime = (value: Date): string => DATE_TIME_FORMAT.format(value)

export const formatRelative = (value: Date, now: Date): string => {
  const elapsed = now.getTime() - value.getTime()
  if (elapsed < 60_000) return '剛剛'
  if (elapsed < 3_600_000) return `${Math.floor(elapsed / 60_000)} 分鐘前`
  if (elapsed < 86_400_000) return `${Math.floor(elapsed / 3_600_000)} 小時前`
  return formatDateTime(value)
}

export type Countdown = { text: string; tone: StatusTone; expired: boolean }

const waitedText = (waitedMs: number): string => {
  const totalMinutes = Math.max(0, Math.floor(waitedMs / 60_000))
  const totalHours = Math.floor(totalMinutes / 60)
  if (totalHours >= HOURS_PER_DAY) return `已等 ${Math.floor(totalHours / HOURS_PER_DAY)} 天 ${totalHours % HOURS_PER_DAY} 小時`
  if (totalHours === 0) return `已等 ${totalMinutes} 分`
  return `已等 ${totalHours} 小時 ${totalMinutes % 60} 分`
}

const toneFor = (remainingMs: number): StatusTone => {
  if (remainingMs <= DM_DEADLINE_WINDOW_MS) return 'danger'
  if (remainingMs <= DM_WARNING_WINDOW_MS) return 'warning'
  return 'neutral'
}

export const replyCountdown = (deadlineAt: Date | null, now: Date): Countdown | null => {
  if (deadlineAt === null) return null
  const remainingMs = deadlineAt.getTime() - now.getTime()
  const waitedMs = DM_REPLY_WINDOW_MS - remainingMs
  if (remainingMs <= 0) return { text: waitedText(waitedMs), tone: 'danger', expired: true }
  return { text: waitedText(waitedMs), tone: toneFor(remainingMs), expired: false }
}
